import { Digraph, Edge, Node, Subgraph } from 'ts-graphviz';
import { StaticLogger } from '@nu-art/ts-common';
import { ModuleFE_PathwayState, ModuleFE_PathwayTransition } from '../../_entity.js';
import { ModuleFE_DiseaseProfile } from '@app/dp-frontend';
const generalId = '00000000000000000000000000000000';
export const convertStateToNode = (state) => {
    return new Node(state._id, {
        id: state._id,
        color: 'blue',
        label: state.name,
        // tooltip: '',
    });
};
export const calculatePathwayAsDigraph = (pathwayId) => {
    if (!pathwayId) {
        StaticLogger.logError('calculatePathwayAsDigraph', 'Can\'t calculate pathway to show with no pathwayId!');
        return;
    }
    const states = ModuleFE_PathwayState.cache.filter(state => state.pathwayIds.includes(pathwayId)); // nodes
    StaticLogger.logInfo('calculatePathwayAsDigraph', `States: ${states.length}. Transitions: ${ModuleFE_PathwayTransition.cache.all().length}`);
    const pathway = new Digraph();
    const container = new Subgraph('Container');
    pathway.addSubgraph(container);
    const nodeToID = {};
    states.forEach(state => {
        const node = convertStateToNode(state);
        nodeToID[state._id] = node;
        container.addNode(node);
    });
    ModuleFE_PathwayTransition.cache.filter(transition => transition.pathwayIds.includes(pathwayId))
        .forEach(transition => {
        if (!ModuleFE_PathwayState.cache.unique(transition.sourceId)) {
            // Some source state id is missing. Skip this transition.
            StaticLogger.logError('calculatePathwayAsDigraph', 'No source id for transition');
            return;
        }
        if (!ModuleFE_PathwayState.cache.unique(transition.targetId)) {
            // Some target state id is missing. Skip this transition.
            StaticLogger.logError('calculatePathwayAsDigraph', 'No target id for transition');
            return;
        }
        //todo currently assume there is only one sourceId and one targetId.
        container.addEdge(new Edge([nodeToID[transition.sourceId], nodeToID[transition.targetId]], {
            color: 'black'
        }));
    });
    return pathway;
};
export const calculatePathwayAsDigraphImpl = (states, transitions, selectedStateIds, dpModule) => {
    // StaticLogger.logInfo('calculatePathwayAsDigraphImpl', `States: ${states.length}. Transitions: ${ModuleFE_PathwayTransition.cache.all().length}. SelectedStateID: ${selectedStateId}`);
    const pathway = new Digraph();
    const container = new Subgraph('Container');
    pathway.addSubgraph(container);
    const nodeToID = {};
    states.forEach(state => {
        const selectedState = selectedStateIds?.includes(state._id);
        if (selectedState)
            StaticLogger.logInfo('calculatePathwayAsDigraphImpl', `States: ${states.length}. Transitions: ${ModuleFE_PathwayTransition.cache.all().length}`);
        const node = new Node(state._id, {
            id: state._id,
            color: selectedState ? '#ff00ff30' : '#1d496f',
            shape: 'rectangle',
            fillcolor: selectedState ? 'yellow' : 'white', // does nothing
            style: 'bold,dashed,solid,filled',
            label: state.name,
            // tooltip: '',
        });
        nodeToID[state._id] = node;
        container.addNode(node);
    });
    transitions.forEach(transition => {
        if (!ModuleFE_PathwayState.cache.unique(transition.sourceId)) {
            // Some source state id is missing. Skip this transition.
            StaticLogger.logError('calculatePathwayAsDigraphImpl', 'No source id for transition');
            return;
        }
        if (!ModuleFE_PathwayState.cache.unique(transition.targetId)) {
            // Some target state id is missing. Skip this transition.
            StaticLogger.logError('calculatePathwayAsDigraphImpl', 'No target id for transition');
            return;
        }
        const selectedStateSource = selectedStateIds?.includes(transition.sourceId);
        const selectedStateTarget = selectedStateIds?.includes(transition.targetId);
        //todo currently assume there is only one sourceId and one targetId.
        container.addEdge(new Edge([nodeToID[transition.sourceId], nodeToID[transition.targetId]], {
            color: selectedStateSource || selectedStateTarget ? 'orange' : 'black',
            label: formatTransitionLabel(transition.dds, dpModule),
        }));
    });
    return pathway;
};
const formatTransitionLabel = (dds, dpModule) => {
    return dds.reduce((labelList, currDD) => {
        const dp = (dpModule ?? ModuleFE_DiseaseProfile).cache.unique(currDD.diseaseProfileId);
        let generalOrAllDps;
        if (!dp)
            generalOrAllDps = currDD.diseaseProfileId === generalId ? 'General' : 'All Dps';
        labelList.push(`${generalOrAllDps ? generalOrAllDps : dp.initials}`);
        return labelList;
    }, []).join(',');
};
//# sourceMappingURL=functions.js.map